module.exports = __webpack_public_path__ + "img/ktv-party_in.7361008c.jpg";